import { generatePagerDutyId } from '../../util/general';

export const indexData = () => {
  const emailId = generatePagerDutyId();
  const phoneId = generatePagerDutyId();
  const smsId = generatePagerDutyId();
  return {
    contact_methods: [
      {
        id: emailId,
        type: 'email_contact_method',
        summary: 'Default',
        self: `https://api.pd-staging.com/users/ABCDEFG/contact_methods/${emailId}`,
        html_url: null,
        label: 'Default',
        address: 'someuser@pagerduty.com',
        send_short_email: false,
        send_html_email: true
      },
      {
        id: phoneId,
        type: 'phone_contact_method',
        summary: 'Other',
        self: `https://api.pd-staging.com/users/ABCDEFG/contact_methods/${phoneId}`,
        html_url: null,
        label: 'Other',
        address: '4165551234',
        blacklisted: false,
        country_code: 1
      },
      {
        id: smsId,
        type: 'sms_contact_method',
        summary: 'Other',
        self: `https://api.pd-staging.com/users/ABCDEFG/contact_methods/${smsId}`,
        html_url: null,
        label: 'Other',
        address: '2899379985',
        blacklisted: false,
        country_code: 1,
        enabled: true
      }
    ],
    total: 3
  };
};

export const createData = (user, { contact_method: payload }) => {
  const contactId = generatePagerDutyId();
  return {
    address: payload.address,
    blacklisted: false,
    country_code: payload.country_code,
    enabled: true,
    html_url: null,
    id: contactId,
    label: payload.label,
    self: `https://api.pd-staging.com/users/${user.id}/contact_methods/${contactId}`,
    summary: 'Other',
    type: payload.type
  };
};
